import React from 'react';
import ToggleButton from './ToggleButton';
import ReactTooltip from 'react-tooltip';
import sha1 from 'crypto-js/sha1';
import moment from 'moment';

class MultiLevelGridHeader extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      HasExpandPanel: this.props.HasExpandPanel === undefined ? false : true,
      topborder: this.props.topborder === undefined ? false : true,
      leftborder: this.props.leftborder === undefined ? false : true,
      rightborder: this.props.rightborder === undefined ? false : true,
      bottomborder: this.props.bottomborder === undefined ? false : true,
      className: this.props.className === undefined ? '' : this.props.className,
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      HasExpandPanel: nextProps.HasExpandPanel === undefined ? false : true,
      topborder: nextProps.topborder === undefined ? false : true,
      leftborder: nextProps.leftborder === undefined ? false : true,
      rightborder: nextProps.rightborder === undefined ? false : true,
      bottomborder: nextProps.bottomborder === undefined ? false : true,
      className: nextProps.className !== undefined ? '' : nextProps.className
    } );
  }

  render(){
    let className = 'multi-level-grid-header';

    if( this.state.className !== undefined ){
      className += ' ' + this.state.className;
    }

    const topborder = this.state.topborder;
    const leftborder = this.state.leftborder;
    const rightborder = this.state.rightborder;
    const bottomborder = this.state.bottomborder;
    const HasExpandPanel = this.state.HasExpandPanel;

    if( topborder === true ){
      className += ' top-border';
    }

    if( leftborder === true ){
      className += ' left-border';
    }

    if( rightborder === true ){
      className += ' right-border';
    }

    if( bottomborder === true ){
      className += ' bottom-border';
    }

    if( this.state.hasError === false ) {

      if( HasExpandPanel === true ){
        return (
          <span className="multi-level-grid-expand" key={this.props.id}>
            <span className={className} >
              {this.props.children}
            </span>
          </span>
        );

      } else {
        return (
          <span key={this.state.id} className={className}>
            {this.props.children}
          </span>
        );

      }

    } else {
      return ( <span></span> );
    }
  }
}

class MultiLevelGridHeaderColumn extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      text: this.props.text === undefined ? '' : this.props.text,
      width: this.props.width === undefined ? 'auto' : this.props.width,
      textAlign: this.props.textAlign === undefined ? 'left' : this.props.textAlign,
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  render(){
    const text = this.state.text;

    const styles = {
      'width': this.state.width,
      'textAlign': this.state.textAlign,
      'overflowX': 'hidden'
    };

    if( this.state.hasError === false ) {
      return (
        <span key={this.props.column} className="multi-level-grid-header-column" style={styles} >
          {text}
        </span>
      );
    } else {
      return ( <span></span> );
    }
  }
}

class MultiLevelGridBody extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      className: this.props.className === undefined ? '' : this.props.className,
      width: this.props.width === undefined ? 'auto' : this.props.width,
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      className: nextProps.className === undefined ? '' : nextProps.className,
      width: nextProps.width === undefined ? 'auto' : nextProps.width
    } );
  }

  render(){
    const width = this.state.width;
    let styles = {};
    styles['width'] = width.toString();
    if( this.state.hasError === false ) {
      return (
        <span className="multi-level-grid-body" style={styles}>
          {this.props.children}
        </span>
      );
    } else {
      return ( <span></span> );
    }
  }
}

class MultiLevelGridRow extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      rowkey: this.props.rowkey === undefined ? '' : this.props.rowkey,
      nodivider: this.props.nodivider === undefined ? false : true,
      cellalign: this.props.cellalign === undefined ? 'auto' : this.props.cellalign,
      HasExpandPanel: this.props.HasExpandPanel === undefined ? false : true,
      ExpandPanelChildren: this.props.ExpandPanelChildren === undefined ? '' : this.props.ExpandPanelChildren,
      ExpandPanelVisible: false,
      hasError: false,
      error: {},
      info: {}
    };

    this.onClickRow = this.onClickRow.bind( this );
    this.onExpandRow = this.onExpandRow.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      rowkey: nextProps.rowkey === undefined ? '' : nextProps.rowkey,
      nodivider: nextProps.nodivider === undefined ? false : true,
      cellalign: nextProps.cellalign === undefined ? 'auto' : nextProps.cellalign,
      HasExpandPanel: nextProps.HasExpandPanel === undefined ? false : true,
      ExpandPanelChildren: nextProps.ExpandPanelChildren === undefined ? '' : nextProps.ExpandPanelChildren,
      ExpandPanelVisible: this.state.ExpandPanelVisible,
    } );
  }

  onExpandRow() {

    const visible = !this.state.ExpandPanelVisible;

    let newstate = {
      ExpandPanelVisible: visible,
    };

    this.setState( newstate );
  }

  onClickRow( e ){
    e.target['rowkey'] = this.state.rowkey;

    if( this.props.onRowClick !== undefined ){
      this.props.onRowClick( e );
    }
  }

  render(){
    const altrow = this.props.altrow === undefined ? false : true;

    let className = 'multi-level-grid-row';

    if( altrow === true ){
      className += ' altrow';
    }

    if( this.state.nodivider === false ){
      className += ' bottom-divider';
    }

    const HasExpandPanel = this.state.HasExpandPanel;
    const ExpandPanelVisible = this.state.ExpandPanelVisible;
    const ExpandPanelChildren = this.state.ExpandPanelChildren;

    let styles = {};

    if( this.state.cellalign.toLocaleLowerCase() === 'topleft' ) {

      styles = {
        'display':'flex',
        'alignItems':'top',
        'justifyContent':'left',
      };

    } else if( this.state.cellalign.toLocaleLowerCase() === 'topcenter' ) {

      styles = {
        'display':'flex',
        'alignItems':'top',
        'justifyContent':'center',
      };
    } else if( this.state.cellalign.toLocaleLowerCase() === 'topright' ) {

      styles = {
        'display':'flex',
        'alignItems':'top',
        'justifyContent':'right',
      };

    }

    if( this.state.hasError === false ) {
      if( HasExpandPanel === true ) {
        return (
          <div key={this.state.rowkey} style={styles} onClick={this.onClickRow}>
            <span className={className} style={styles}>
              <MultiLevelGridRowExpandCell expanded={ExpandPanelVisible} onExpandRow={this.onExpandRow} />
              {this.props.children}
            </span>
            <MultiLevelGridRowExpandPanel expanded={ExpandPanelVisible} >
              {ExpandPanelChildren}
            </MultiLevelGridRowExpandPanel>
          </div>
        );
      } else {

        return (
          <div key={this.state.rowkey} onClick={this.onClickRow}>
            <span className={className} style={styles}>
              {this.props.children}
            </span>
          </div>
        );

      }
    } else {
      return ( <div></div> );
    }
  }
}

class MultiLevelGridImportantRow extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      rowkey: this.props.rowkey === undefined ? '' : this.props.rowkey,
      cellalign: this.props.cellalign === undefined ? 'auto' : this.props.cellalign,
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      rowkey: nextProps.rowkey === undefined ? '' : nextProps.rowkey,
      cellalign: nextProps.cellalign === undefined ? 'auto' : nextProps.cellalign,
    } );
  }

  render(){

    const className = 'multi-level-grid-important-row';

    let styles = {};

    if( this.state.cellalign.toLocaleLowerCase() === 'topleft' ) {

      styles = {
        'display':'flex',
        'alignItems':'top',
        'justifyContent':'left',
      };

    } else if( this.state.cellalign.toLocaleLowerCase() === 'topcenter' ) {

      styles = {
        'display':'flex',
        'alignItems':'top',
        'justifyContent':'center',
      };
    } else if( this.state.cellalign.toLocaleLowerCase() === 'topright' ) {

      styles = {
        'display':'flex',
        'alignItems':'top',
        'justifyContent':'right',
      };

    }

    if( this.state.hasError === false ) {
      return (
        <div key={this.state.rowkey}>
          <span className={className} style={styles}>
            {this.props.children}
          </span>
        </div>
      );
    } else {
      return ( <div></div> );
    }
  }
}

class MultiLevelGridRowExpandCell extends React.Component {

  constructor( props ){
    super( props );

    this.state = {
      expanded: this.props.expanded === undefined ? false : this.props.expanded,
      hasError: false,
      error: {},
      info: {}
    };

    this.onHandleClick = this.onHandleClick.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( { expanded: nextProps.expanded } );
  }

  onHandleClick( e ){
    if( this.props.onExpandRow !== undefined ){
      this.props.onExpandRow();
    }
  }

  render(){
    const expanded = this.state.expanded;
    if( this.state.hasError === false ) {
      if( expanded === true ){
        return (
          <span className="multi-level-grid-row-expand-cell">
            <i className="multi-level-grid-row-expand-cell-icon icon-feather-square-minus" onClick={this.onHandleClick} />
          </span>
        );
      } else {
        return (
          <span className="multi-level-grid-row-expand-cell">
            <i className="multi-level-grid-row-expand-cell-icon icon-feather-square-plus" onClick={this.onHandleClick} />
          </span>
        );
      }
    } else {
      return ( <span></span> );
    }
  }
}

class MultiLevelGridRowLabelCell extends React.Component {

  constructor( props ){
    super( props );

    // Used as the identifiers
    let _column = this.props.column === undefined ? '' : this.props.column;
    let _text = this.props.text === undefined || this.props.text === null ? '' : this.props.text;
    let _rid = Math.random();

    this.state = {
      column: _column,
      text: _text.toString(),
      format: this.props.format === undefined ? '' : this.props.format,
      dateFormat: this.props.dateFormat === undefined ? '' : this.props.dateFormat,
      precision: this.props.precision === undefined ? 0 : parseInt( this.props.precision, 10 ),
      width: this.props.width === undefined ? 'auto' : this.props.width,
      textAlign: this.props.textAlign === undefined ? 'left' : this.props.textAlign,
      tooltip: this.props.tooltip === undefined ? false : true,
      backgroundColor: this.props.backgroundColor === undefined ? 'none' : this.props.backgroundColor,
      color: this.props.color === undefined ? 'none' : this.props.color,
      showtooltip: false,
      // The id used by the tooltip to render, react-tooltip uses (id) as reference
      // Collisions would be 'possible' at (16**14) - 1 or 72057594037927935 generations in a perfect world,
      // Math.random() and equal values of _column, _text ~ make this a worst case of relying on
      // (1)/16 * clock-tick-precision or  ~.625%  (less than 1%) if all are the same.
      tooltip_id: 'id_mlgrlc_' + String( sha1( _column + '_' + _text + '_' + _rid ) ).slice( 2,16 ),
      // Holds if the component is ellipsed
      over: null,
      hasError: false,
      error: {},
      info: {}
    };

    // Bindings
    this.onMouseMove = this.onMouseMove.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    let _text = nextProps.text === undefined || nextProps.text === null ? this.state.text : nextProps.text;    
    this.setState( {
      column: nextProps.column === undefined ? '' : nextProps.column,
      format: nextProps.format === undefined ? '' : nextProps.format,
      dateFormat: nextProps.dateFormat === undefined ? '' : nextProps.dateFormat,
      precision: nextProps.precision === undefined ? 0 : parseInt( nextProps.precision, 10 ),
      width: nextProps.width === undefined ? 'auto' : nextProps.width,
      textAlign: nextProps.textAlign === undefined ? 'left' : nextProps.textAlign,
      tooltip: nextProps.tooltip === undefined ? false : true,
      text: _text.toString(),
      backgroundColor: nextProps.backgroundColor === undefined ? 'none' : nextProps.backgroundColor,
      color: nextProps.color === undefined ? 'none' : nextProps.color,
    } );

  }

  format( text, format, precision, dateFormat ){
    let value;
    let formattedvalue;
    let dateString;

    if( format === 'date' ){

      if( dateFormat === '' ){
        dateFormat = 'YYYY-MM-DD';
      }

      dateString = moment( text ).format( dateFormat );
      return dateString;
    }

    if( format === 'time' ){

      if( dateFormat === '' ){
        dateFormat = 'HH:mm:ss.SSS';
      }

      dateString = moment( text ).format( dateFormat );
      return dateString;
    }


    if( format === 'datetime' ){

      if( dateFormat === '' ){
        dateFormat = 'YYYY-MM-DD HH:mm:ss.SSS';
      }

      dateString = moment( text ).format( dateFormat );
      return dateString;
    }

    if( format === 'usdollar' ){
      value = parseFloat( text ).toFixed( precision );
      return '$' + parseFloat( text ).toFixed( precision ).toString();
    }

    if( format === 'usdollarwithcommas' ){

      value = parseFloat( text ).toFixed( precision );
      formattedvalue = value.toString().replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,' );
      return '$' + formattedvalue.toString();
    }

    if( format === 'numberwithcommas' ){
      value = parseFloat( text ).toFixed( precision );
      formattedvalue = value.toString().replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,' );
      return formattedvalue;
    }

    if( format === 'decimal' ){
      value = parseFloat( text ).toFixed( precision );
      return value.toString();
    }

    if( format === 'tel' ) {
      value = text.replace( /\D/g, '' );
      if ( value.match( /^[2-9][\d]{2}[2-9][\d]{6}$/ ) ){
        return `+1 (${value.slice( 0, 3 )}) ${value.slice( 3, 6 )} - ${value.slice( 6, 10 )}`;
      } else if ( value.match( /^1[2-9][\d]{2}[2-9][\d]{6}$/ ) ){
        return `+1 (${value.slice( 1, 4 )}) ${value.slice( 4, 7 )} - ${value.slice( 7, 11 )}`;
      } else if ( value[0] !== 1 && value.length>10 ) {
        return `+1 (${value.slice( 0, 3 )}) ${value.slice( 3, 6 )}-${value.slice( 6, 10 )} ex ${value.slice( 10, value.length )}`;
      } else if ( value[0] === 1 && value.length>10 ) {
        return `+1 (${value.slice( 1, 4 )}) ${value.slice( 4, 7 )}-${value.slice( 7, 11 )} ex ${value.slice( 11, value.length )}`;
      }
    }

    return text;
  }

  /* Optimized to determine if the element needs a tooltip or not */
  onMouseOver( e ){

    let over = this.state.over;

    // Performs a one time 'expensive' calculation
    // to see if the element is ellipsed
    if( over === null ){
      // Checks to see that the size if over the display size
      let elem = document.getElementById( this.state.tooltip_id );
      over = false;

      // Checks size of what-is-given to what-is-rendered
      if ( elem.scrollWidth > elem.clientWidth ) {
        over = true;
      }

      // Shows the tooltip only if there's something to show
      if( this.state.text !== '' && over ){
        this.setState( { showtooltip: true, over: true } );
      } else {
        this.setState( {over: false} );
      }
    } else {

      // Post elem.scrollWidth calc
      if( over ){
        this.setState( { showtooltip: true } );
      }
    }
  }

  /* Sets the state back to false on leaving */
  onMouseLeave( e ){
    this.setState( { showtooltip: false } );
  }

  /* Checks if the tooltip is within view */
  onMouseMove( e ){
    let over = this.state.over;

    // Checks that a tooltip applies
    if( over !== null && over ){
      let elem = document.getElementById( this.state.tooltip_id + '_hover_text' );

      if( elem ){
        let bound = elem.getBoundingClientRect();
        let window_x = window.screen.width;

        // Dynamically changes the internals to fit inside if the outermost right if overflowing
        if( window_x < bound.right ){

          // Max size, 8 Because we want the middle of the middle display || or (2/2/2), though
          // this works well for large displays. The same will probably not translate well to small displays
          let line_limit = Math.floor( ( window_x / Math.ceil( bound.right / window_x ) ) / 8 );

          let internal_text = this.state.text.split( ' ' );
          let new_text = ''; // Replacement

          // Current size of the replacement string
          let csize = 0;
          let i;
          let chrl;

          // If no spaces are found (very long string)
          if( internal_text.length === 1 ){
            internal_text = [];

            for ( i = 0, chrl = this.state.text.length; i < chrl; i += line_limit ) {
              internal_text.push( this.state.text.substring( i, i + line_limit ) );
            }

            for( i = 0; i < internal_text.length; i++ ){
              new_text = new_text + internal_text[i];
            }
          // Standard space out string
          } else {
            for( i = 0; i < internal_text.length; i++ ){

              // Offset 1 for the white space
              csize = csize + internal_text[i].length + 1;
              new_text = new_text + internal_text[i] + ' ';

              // Check if the limit has been reached
              if( csize >= line_limit ){
                new_text = new_text + '<br>';
                csize = 0; // Reset the counter
              }
            }
          }
          // Set the new inner text
          elem.innerHTML = new_text;
        }
      }
    }
  }

  render(){

    if( this.state.hasError === false ) {

      const text = this.format( this.state.text, this.state.format, this.state.precision, this.state.dateFormat );

      let styles = {
        'display':'inline-block',
        'paddingTop': '5px',
        'paddingLeft': '5px',
        'width': this.state.width,
        'textAlign': this.state.textAlign,
        'fontWeight': this.props.bold === undefined ? 'normal' : 'bold',
        'backgroundColor': this.state.backgroundColor,
        'color': this.state.color,
      };

      const link_styles = {
        'backgroundColor': this.state.backgroundColor,
        'color': this.state.color,
      };

      let tooltipcontrol = '';
      if( this.state.tooltip === true && this.state.showtooltip === true ){
        tooltipcontrol = (
          <ReactTooltip id={this.state.tooltip_id }>
            <span id={this.state.tooltip_id + '_hover_text'}>{text}</span>
          </ReactTooltip>
        );
      }

      let mouse_over_target;

      // Adds an event for size
      if( this.state.over !== null && this.state.over ){
        mouse_over_target = (
          <a data-tip style={link_styles} data-for={this.state.tooltip_id} className="multi-level-grid-row-label-cell" onMouseMove={this.onMouseMove}>
            {text}
          </a>
        );
      } else {

        // No event listerner (less calls ~ optimized)
        mouse_over_target = (
          <a data-tip style={link_styles} data-for={this.state.tooltip_id} className="multi-level-grid-row-label-cell">
            {text}
          </a>
        );
      }

      return (
        <span id={this.state.tooltip_id} className="multi-level-grid-row-label-cell" style={styles} onMouseOver={this.onMouseOver.bind( this )} onMouseLeave={this.onMouseLeave.bind( this )}>
          {mouse_over_target}
          {tooltipcontrol}
        </span>
      );

    } else {
      return ( <span></span> );
    }
  }
}

class MultiLevelGridRowTextBoxCell extends React.Component {

  constructor( props ){
    super( props );

    this.state = {
      scrollable: this.props.scrollable ? false : true,
      column: this.props.column === undefined ? '' : this.props.column,
      rowIndex: this.props.rowIndex === undefined ? 0 : parseInt( this.props.rowIndex, 0 ),
      text: this.props.text === undefined ? '' : this.props.text,
      format: this.props.format === undefined ? '' : this.props.format,
      precision: this.props.precision === undefined ? 0 : this.props.precision,
      width: this.props.width === undefined ? 'auto' : this.props.width,
      height: this.props.height === undefined ? 'auto' : this.props.height,
      textAlign: this.props.textAlign === undefined ? 'left' : this.props.textAlign,
      placeholder: this.props.placeholder === undefined ? '' : this.props.placeholder,
      resizable: this.props.resizable === undefined ? false : true,
      hasError: false,
      error: {},
      info: {}
    };

    this.onChange = this.onChange.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){

    this.setState( {
      scrollable: nextProps.scrollable ? false : true,
      placeholder: nextProps.placeholder === undefined ? '' : nextProps.placeholder,
      textAlign: nextProps.textAlign === undefined ? 'left' : nextProps.textAlign,
      width: nextProps.width === undefined ? 'auto' : nextProps.width,
      text: nextProps.text,
    } );

  }

  format( text, format, precision ){
    var value;
    var formattedvalue;

    if( format === 'usdollar' ){
      return '$' + parseFloat( text ).toFixed( precision ).toString();
    }

    if( format === 'usdollarwithcommas' ){
      value = parseFloat( text ).toFixed( precision );
      formattedvalue = value.toString().replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,' );
      return '$' + formattedvalue.toString();
    }

    if( format === 'numberwithcommas' ){
      value = parseFloat( text ).toFixed( precision );
      formattedvalue = value.toString().replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,' );
      return formattedvalue;
    }
    return text;
  }

  onChange( e ){

    if( this.props.onChange !== undefined ){

      e.target.rowIndex = this.state.rowIndex;
      e.target.column = this.state.column;

      this.props.onChange( e );

    } else {

      this.setState( {text: e.target.value} );

    }
  }

  render(){

    const text = this.format( this.state.text,this.state.format,this.state.precision );

    const styles = {
      'width': this.state.width,
      'height': this.state.height,
      'textAlign': this.state.textAlign,
    };

    if( this.state.scrollable === true ){
      styles['overflow'] = 'auto';
    }

    if( this.state.hasError === false ) {
      if( this.state.resizable === true ){
        return (
          <textarea id={this.props.id} placeholder={this.state.placeholder} rows="3" cols="1" className="multi-level-grid-row-textbox-cell" style={styles} value={text} onChange={this.onChange} />
        );
      } else {
        styles['resize'] = 'none';
        return (
          <textarea id={this.props.id} placeholder={this.state.placeholder} rows="3" cols="1" className="multi-level-grid-row-textbox-cell" style={styles} value={text} onChange={this.onChange} />
        );
      }
    } else {
      return ( <span></span> );
    }
  }

}

class MultiLevelGridRowDropdownCell extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      column: this.props.column === undefined ? '' : this.props.column,
      rowIndex: this.props.rowIndex === undefined ? 0 : this.props.rowIndex,
      options:  this.props.options === undefined ? [] : this.props.options,
      width: this.props.width === undefined ? 'auto' : this.props.width,
      height: this.props.height === undefined ? 'auto' : this.props.height,
      value: this.props.value === undefined ? '' : this.props.value
    };
    this.onHandleChange = this.onHandleChange.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    this.setState( {
      column: nextProps.column === undefined ? '' : nextProps.column,
      rowIndex: nextProps.rowIndex === undefined ? 0 : nextProps.rowIndex,
      options: nextProps.options === undefined ? [] : nextProps.options,
      width: nextProps.width === undefined ? 'auto' : nextProps.width,
      height: nextProps.height === undefined ? 'auto' : nextProps.height,
      value: nextProps.value === undefined ? '' : nextProps.value
    } );
  }

  onHandleChange( e ) {
    e.target.column = this.state.column;
    e.target.rowIndex = this.state.rowIndex;
    if( this.props.onChange !== undefined ) {
      this.props.onChange( e );
    } else {
      this.setState( {
        value: e.target.value
      } );
    }
  }

  onRenderOptions( ) {
    const options = this.state.options;
    let renderOptions = [];
    if( options !== undefined ) {
      if( options.length > 0 ) {
        for( var index = 0; index < options.length; index++ ) {
          const option = options[ index ];
          const optionkey = 'multi-level-grid-dropdown-cell-option-' + index.toString();
          renderOptions.push(
            <option key={optionkey} value={option.value}>{option.text}</option>
          );
        }
      }
    }
    return renderOptions;
  }

  render(){
    const styles = {
      'width': this.state.width,
      'height': this.state.height
    };
    return (
      <select value={this.state.value} onChange={this.onHandleChange} styles={styles}>
        {this.onRenderOptions()}
      </select>
    );
  }
}

class MultiLevelGridRowButtonCell extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      text: this.props.text === undefined ? '' : this.props.text,
      width: this.props.width === undefined ? 'auto' : this.props.width,
      btnClass: this.props.btnClass === undefined ? 'btn-outlined btn btn-sm btn-default' : this.props.btnClass,
      hasError: false,
      error: {},
      info: {}
    };

    this.onHandleClick = this.onHandleClick.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      text: nextProps.text === undefined ? this.state.text : nextProps.text,
      width: nextProps.width === undefined ? 'auto' : nextProps.width,
      btnClass: nextProps.btnClass === undefined ? 'btn-outlined btn btn-sm btn-default' : nextProps.btnClass,
    } );
  }

  onHandleClick( e ){
    if( this.props.onButtonClick !== undefined ){
      e.target['eventargs'] = this.props.eventargs;
      this.props.onButtonClick( e );
    }
  }

  render(){
    let styles = {
      'width': this.state.width
    };

    if( this.state.hasError === false ) {
      return (
        <span className="multi-level-grid-row-button-cell" style={styles}>
          <button className={this.state.btnClass} onClick={this.onHandleClick}>
            {this.state.text}
          </button>
        </span>
      );
    } else {
      return ( <span></span> );
    }
  }
}

class MultiLevelGridRowToggleButtonCell extends React.Component {
  constructor( props ){
    super( props );
    this.state = {
      active: this.props.active === undefined ? false : this.props.active,
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  render( ) {
    if( this.state.hasError === false ) {
      return (
        <span className="multi-level-grid-row-button-cell">
          <ToggleButton is_switched_on={this.state.active} caption="" />
        </span>
      );
    } else {
      return (
        <span></span>
      );
    }
  }
}

class MultiLevelGridRowIconCell extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      icon: this.props.icon === undefined ? 'icon-fontello-blank' : this.props.icon,
      text: this.props.text === undefined ? '' : this.props.text,
      onShowNotes: this.props.onShowNotes,
      hasError: false,
      error: {},
      info: {}
    };
    this.onMouseEnter = this.onMouseEnter.bind( this );
    this.onMouseLeave = this.onMouseLeave.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      icon: nextProps.icon,
      text: nextProps.text,
      showtooltip: false,
    } );
  }

  onMouseEnter( e ){
    this.setState( { showtooltip: true } );
  }

  onMouseLeave( e ){
    this.setState( { showtooltip: false } );
  }

  render(){
    if( this.state.hasError === false ) {
      let icon = this.state.icon;
      let tooltip = '';

      let styles = {
        'paddingTop':'10px',
        'paddingLeft':'25px',
        'paddingRight':'25px',
        'paddingBottom':'10px',
        'borderTop':'dashed 1pt black',
        'borderLeft':'dashed 1pt black',
        'borderRight':'dashed 1pt black',
        'borderBottom':'dashed 1pt black',
        'cursor':'pointer',
      };

      let iconstyles = {
        'fontSize':'14pt',
      };

      return (
        <span key={this.props.key} style={styles} >
          <i className={icon} style={iconstyles} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} />
          {tooltip}
        </span>
      );
    } else {
      return ( <span></span> );
    }
  }
}

class MultiLevelGridRowExpandPanel extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      expanded: this.props.expanded === undefined ? false : this.props.expanded,
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      expanded: nextProps.expanded === undefined ? false : nextProps.expanded
    } );
  }

  render(){
    if( this.state.hasError === false ) {
      if( this.state.expanded === true ){
        return (
          <span key="multi-level-grid-row-expand-panel">
            <span className="multi-level-grid-expand-panel-expanded">
              {this.props.children}
            </span>
          </span>
        );
      } else {
        return (
          <span key="multi-level-grid-row-expand-panel">
            <span className="multi-level-grid-expand-panel-collapsed">
            </span>
          </span>
        );
      }
    } else {
      return ( <span></span> );
    }
  }
}

class MultiLevelGridFooter extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      className: this.props.className === undefined ? '' : this.props.className,
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      className: nextProps.className === undefined ? '' : nextProps.className,
    } );
  }

  render(){

    let className = '';

    if( this.state.className !== '' ){
      className += ' ' + this.state.className;
    }

    if( this.state.hasError === false ) {
      return (
        <span className={className}>
          {this.props.children}
        </span>
      );
    } else {
      return ( <span></span> );
    }
  }
}

class MultiLevelGrid extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      topborder: this.props.topborder === undefined ? false : true,
      leftborder: this.props.leftborder === undefined ? false : true,
      rightborder: this.props.rightborder === undefined ? false : true,
      bottomborder: this.props.bottomborder === undefined ? false : true,
      className: this.props.className === undefined ? '' : this.props.className,
      style: this.props.style === undefined ? {} : this.props.style,
      hasError: false,
      error: {},
      info: {}
    };
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      topborder: nextProps.topborder === undefined ? false : true,
      leftborder: nextProps.leftborder === undefined ? false : true,
      rightborder: nextProps.rightborder === undefined ? false : true,
      bottomborder: nextProps.bottomborder === undefined ? false : true,
      className: nextProps.className === undefined ? '' : nextProps.className,
      style: nextProps.style === undefined ? {} : nextProps.style
    } );
  }

  render(){

    if( this.state.hasError === false ) {
      let className = 'multi-level-grid';
      const topborder = this.state.topborder;
      const leftborder = this.state.leftborder;
      const rightborder = this.state.rightborder;
      const bottomborder = this.state.bottomborder;

      if( topborder === true ){
        className += ' top-border';
      }

      if( leftborder === true ){
        className += ' left-border';
      }

      if( rightborder === true ){
        className += ' right-border';
      }

      if( bottomborder === true ){
        className += ' bottom-border';
      }

      return (
        <div key={this.props.id} className={className}>
          {this.props.children}
        </div>
      );

    } else {
      return ( <div></div> );
    }
  }
}

export {
  MultiLevelGrid,
  MultiLevelGridHeader,
  MultiLevelGridHeaderColumn,
  MultiLevelGridBody,
  MultiLevelGridRow,
  MultiLevelGridImportantRow,
  MultiLevelGridRowExpandCell,
  MultiLevelGridRowLabelCell,
  MultiLevelGridRowTextBoxCell,
  MultiLevelGridRowDropdownCell,
  MultiLevelGridRowButtonCell,
  MultiLevelGridRowToggleButtonCell,
  MultiLevelGridRowIconCell,
  MultiLevelGridRowExpandPanel,
  MultiLevelGridFooter,
};



// WEBPACK FOOTER //
// ./src/presentation/MultiLevelGrid.js